import { Locale } from '@synergy/models';

export const localeReducer = (state: Locale[] = []) => {
    return state;
};
